import { AnyAction } from 'redux';
import { ResourceState } from '@mews-commander/data-access';
import { CommanderThunkAction } from '@mews-commander/types';
import { updateResourcesState } from '@mews-commander/legacy-entities/src/actions/resources';
import { checkIn } from '@mews-commander/legacy-entities/src/ducks/reservations';
import { getCurrentEnterpriseReservationAssignedResourceId } from '@mews-commander/legacy-entities/src/selectors/reservations';

interface SetInspectedAndCheckInProps {
    reservationId: string;
    disablePreauthorization?: boolean;
    makeResourceInspected?: boolean;
}

export const setInspectedAndCheckIn =
    ({
        reservationId,
        disablePreauthorization,
        makeResourceInspected,
    }: SetInspectedAndCheckInProps): CommanderThunkAction<AnyAction, Promise<unknown>> =>
    async (dispatch, getState) => {
        if (makeResourceInspected) {
            const assignedResourceId = getCurrentEnterpriseReservationAssignedResourceId(getState(), {
                id: reservationId,
            });
            await dispatch(
                updateResourcesState({
                    resourceIds: [assignedResourceId],
                    state: ResourceState.Inspected,
                    stateReason: null,
                })
            );
        }
        return dispatch(checkIn([reservationId], disablePreauthorization));
    };
